<template>
    <ion-grid>
        <ion-row>
            <ion-col size="3" class="ion-no-padding">
                <ion-button color="dark" size="large" @click="dec()" expand="block" :class="'stepper-button-' + size">
                    <ion-icon :icon="chevronBack"/>
                </ion-button>
            </ion-col>
            <ion-col size="6">
                <ion-item>
                    <ion-label position="floating">{{ label }}</ion-label>
                    <ion-input
                        :step="step"
                        :min="min"
                        :max="max > -1?max:99999"
                        ref="input"
                        type="number"
                        :class="'ion-text-center input-' + size"
                        v-model.number="quantity"
                        @ionBlur="update"
                        @keypress.enter="$emit('enter')"
                        @ionFocus="clearOnZero()"
                    />
                    <span class="units" v-show="units">{{ units }}</span>
                </ion-item>
            </ion-col>
            <ion-col size="3" class="ion-no-padding">
               <ion-button color="dark" size="large" @click="inc()" expand="block" :class="'stepper-button-' + size">
                  <ion-icon :icon="chevronForward"/>
               </ion-button>
            </ion-col>
        </ion-row>
    </ion-grid>
</template>

<script>

import {IonInput, IonButton, IonIcon, IonItem, IonLabel, IonGrid, IonRow, IonCol} from '@ionic/vue';
import {chevronForward, chevronBack} from 'ionicons/icons';
import {computed} from 'vue';

export default {
    name: "BigStepper",
    props: {
        step: {type: Number, default: 1},
        min: {type: Number, default: 0},
        max: {type: Number, default: -1},
        modelValue: {default: '0'},
        label: {default: 'Quantity', type: String},
        units: {default: ''},
        size: {default: 'large'}
    },
    emits: ['update:modelValue', 'enter'],
    components: {IonInput, IonButton, IonIcon, IonGrid, IonRow, IonCol, IonLabel, IonItem},
    methods: {
        inc() {
            if (this.max < 0 || (this.quantity < this.max)) {
                this.quantity++;
            }
        },
        dec() {
            if (this.quantity > this.min) {
                this.quantity--;
            }
        },
        focus() {
            this.$refs['input'].$el.setFocus();
        },
        clearOnZero() {
            if (this.quantity == 0) {
                this.quantity = '';
            }
        },
        update(event) {
            const value = event.target.value;
            if (value === '') {
                event.preventDefault();
                this.$emit('update:modelValue', 0);
            } else {
                this.$emit('update:modelValue', value);
            }
        }
    },
    setup(props, {emit}) {
        // Explanation of how to get v-model working in Vue 3:
        // https://www.vuemastery.com/blog/vue-3-data-down-events-up/
        const quantity = computed({
            get: () => props.modelValue,
            set: (value) => emit('update:modelValue', value)
        });
        return {
            quantity,
            chevronBack,
            chevronForward,
        };
    }
}
</script>

<style scoped>
span.units {
    position: absolute;
    bottom: 0;
    right: 0;
}

ion-grid, ion-col {
    background-color: var(--ion-background-color);
}

ion-button, ion-button.medium {
    height: 75%;
    margin-top: 0.3em;
}

ion-button.large {
    height: 95%;
}

ion-input.input-large {
    font-size: 200%;
}

ion-input.input-medium {
    font-size: 100%;
}

ion-grid {
    display: block;
    width: 100%;
}

</style>
